// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuSeparator_wrapper__kGTmB","line":"MenuSeparator_line__awUwG"};